import classnames from 'clsx'
import { arrayOf, shape, string } from 'prop-types'

import BannerCard from 'views/components/organisms/HeaderNew/BannerCard'
import MenuCardItem from 'views/components/organisms/HeaderNew/MenuCardItem'
import SubmenuCardTitle from 'views/components/organisms/HeaderNew/SubmenuCardTitle'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { publicRuntimeConfigType } from 'views/utils/propTypes'

const getTitleBlock = ({
  titleWrapperClasses,
  title,
  visuallyHidden = false,
  index,
}) => (
  <div
    className={classnames(titleWrapperClasses)}
    key={`card-title${title || index}`}
  >
    {title && (
      <SubmenuCardTitle visuallyHidden={visuallyHidden}>
        {title}
      </SubmenuCardTitle>
    )}
  </div>
)

const MenuSection = ({
  sectionClassNames,
  banners,
  menuLinks,
  titleWrapperClasses,
  cardClasses,
  boxClasses,
  publicRuntimeConfig: {
    publicConfig: { deviceClass },
  },
}) => (
  <div className={classnames('u-background-color--greySky', sectionClassNames)}>
    <div className="o-MenuSection--headings u-visuallyhidden@small-tiny l-flex@medium l-flex--start@medium">
      {menuLinks.map(({ title }, index) =>
        getTitleBlock({ title, titleWrapperClasses, index })
      )}
      {!!banners.length &&
        getTitleBlock({
          titleWrapperClasses,
          title: 'Ad Section',
          index: menuLinks.length,
          visuallyHidden: true,
        })}
    </div>
    <div className="l-flex@medium l-flex--stretch-children@medium u-padding-large--bottom">
      {menuLinks.map((section, index) => (
        <MenuCardItem
          key={index}
          section={section}
          boxClasses={boxClasses}
          cardClasses={classnames(cardClasses, {
            // 'u-no-padding--bottom@small-tiny': index,
          })}
        />
      ))}

      <div
        className={classnames(
          cardClasses,
          'u-margin-large--left@medium',
          'l-flex',
          'l-flex__column',
          'u-padding-large@small-tiny',
          'l-flex--stretch-children@small-tiny'
        )}
      >
        {banners.map((banner, index) => {
          if (banner.isImage) {
            return (
              <a
                data-qa-id={banner.qa}
                className={banner.className}
                href={banner.link}
              >
                <img alt={banner.link} src={banner.imageURL} />
              </a>
            )
          } else {
            return (
              <BannerCard
                key={index}
                cardClasses={classnames({
                  'u-margin-large--bottom': index !== banners.length - 1,
                })}
                title={banner.title}
                imageURL={banner.imageURL}
                text={banner.text}
                link={banner.link}
                openInNewTab={banner.openInNewTab}
                deviceClass={deviceClass}
              />
            )
          }
        })}
      </div>
    </div>
  </div>
)

MenuSection.propTypes = {
  banners: arrayOf(shape({})).isRequired,
  menuLinks: arrayOf(shape({})).isRequired,
  sectionClassNames: string,
  titleWrapperClasses: string,
  cardClasses: string,
  boxClasses: string,
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
}

MenuSection.defaultProps = {
  titleWrapperClasses: undefined,
  sectionClassNames: undefined,
  cardClasses: undefined,
  boxClasses: undefined,
  banners: [],
}

export default withShopAndRuntimeConfig(MenuSection)
